export default "__VITE_ASSET__BEE2Dj4I__"